import * as React from 'react';
import {
    ShowButton,
    List,
    Datagrid,
    ReferenceField,
    TextField,
    EditButton,
    ReferenceInput,
    SelectInput,
    TextInput,
    Filter,
    Pagination,
} from 'react-admin';

const ProjectFilter = props => (
    <Filter {...props}>
        <TextInput label="Search" source="q" alwaysOn />
        <ReferenceInput
            label="Instances"
            source="instance_id"
            reference="instances"
            allowEmpty
        >
            <SelectInput optionText="name" />
        </ReferenceInput>
    </Filter>
);

const ProjectPagination = props => <Pagination rowsPerPageOptions={[10, 25, 50, 100]} {...props} />;


const ProjectList = props => (
    <List {...props} 
        filters={<ProjectFilter />} 
        perPage={25}
        pagination={<ProjectPagination />}>
        <Datagrid>
            <TextField source="id" />
            <TextField source="name" />
            <ReferenceField label="Instances" source="instance_id" reference="instances">
                <TextField source="name" />
            </ReferenceField>
            <EditButton />
            <ShowButton />
        </Datagrid>
    </List>
);

export default ProjectList;